// app/utils/dashboardLayoutStorage.ts
const DASHBOARD_LAYOUT_STORAGE_KEY = "dashboard_selected_layout";

export interface StoredDashboardLayout {
  layoutId: number;
  layoutName: string;
}

const isStoredDashboardLayout = (
  value: unknown,
): value is StoredDashboardLayout => {
  if (!value || typeof value !== "object") return false;
  const candidate = value as Record<string, unknown>;
  return (
    typeof candidate.layoutId === "number" &&
    typeof candidate.layoutName === "string"
  );
};

export const readStoredDashboardLayout = (): StoredDashboardLayout | null => {
  try {
    const raw = localStorage.getItem(DASHBOARD_LAYOUT_STORAGE_KEY);
    if (!raw) return null;

    const parsed: unknown = JSON.parse(raw);
    return isStoredDashboardLayout(parsed) ? parsed : null;
  } catch (err) {
    console.log("Error in readStoredDashboardLayout::", err);
    return null;
  }
};

export const writeStoredDashboardLayout = (
  layout: StoredDashboardLayout,
): void => {
  try {
    localStorage.setItem(DASHBOARD_LAYOUT_STORAGE_KEY, JSON.stringify(layout));
  } catch (err) {
    console.log("Error in writeStoredDashboardLayout::", err);
  }
};
